import { combineReducers } from "redux";
import { reducer as formReducer } from "redux-form";
import mdaeCommonReducer from "../common_components/mdae-common-reducer";
import documentManagementReducer from "../common_components/document-management/reducers/document-management-reducer";
import mdaeNavigationBarReducer from "../common_components/common_widgets/navigation_bar/reducers/mdae-navigation-bar-reducer";
import mdaePageHeaderReducer from "../common_components/common_widgets/mdae-page-header/reducers/mdae-page-header-reducer";
import appReducer from "../app/reducers/appReducer";
import taskTemplateReducer from "../pages/task-template/reducers/task-template-reducer";
import categoryManagementReducer from "../pages/category-management/reducers/category-management-reducer";
import myTaskReducer from "../common_components/user-task-card-view/reducers/user-task-card-view-reducer";
import userTaskListReducer from "../common_components/user-task-list/reducers/user-task-list-reducer";
import outcomesReducer from "../pages/external-audit-setup/outcomes/reducers/outcomes-reducers";
import auditViewUserTaskListReducer from "../common_components/user-task-list/reducers/audit-view-user-task-list-reducer";
import processTemplateReducer from "../pages/external-audit-setup/process-template/reducer/process-template-reducer";
import bellCurveReportParameterReducer from "../common_components/bell-curve-report-parameter/reducers/bell-curve-report-parameter-reducer";
import requesterReducer from "../pages/external-audit-setup/requestor-and-sources/requester/reducers/requester-reducer";
import externalAuditReducer from "../pages/external-audit/reducers/external-audit-reducer";
import caseFieldsReducer from "../common_components/case-details/reducers/case-fields-reducer";
import caseDetailReducer from "../pages/external-audit/case-detail/reducers/case-detail-reducer";
import notificationAndSystemMessagesReducer from "../common_components/common_widgets/notification-and-system-messages-module/reducers/notification-and-system-messages-reducer";
import auditPropertiesReducer from "../pages/external-audit/reducers/audit-properties-reducer";
import sourcesReducer from "../pages/external-audit-setup/requestor-and-sources/sources/reducers/sources-reducer";
import auditListReducer from "../pages/external-audit/audit-list/reducers/audit-list-reducer";
import roundTaskReducer from "../pages/external-audit/reducers/round-task-reducer";
import caseCountReducer from "../pages/external-dashboard/dashboard-widgets/case-volume/reducers/case-count-list-reducer";
import eaDashboardReducer from "../pages/external-dashboard/reducers/ea-dashboard-reducer";
import myTaskDasboardReducer from "../pages/external-dashboard/dashboard-widgets/my-tasks/reducer/my-task-dashboard-reducer";
import myExternalAuditByStatusReducer from "../pages/external-dashboard/dashboard-widgets/my-external-audit-by-status/reducers/my-external-audits-status-reducer";
import caseSearchReducer from "../common_components/case-search/reducers/case-search-reducer";
import caseListReducer from "../pages/external-audit/case-list/reducers/case-list-reducer";
import bulkUpdatePopupReducer from "../common_components/bulk-update-popup/reducers/bulk-update-popup-reducer";
import manageDeletedExternalAudit from "../pages/external-audit-setup/manage-deleted-external-audit/reducers/manage-deleted-external-audit-reducer";
import billHistoryReducer from "../pages/external-audit/case-list/reducers/bill-history-reducer";
import caseDataReducer from "../pages/external-audit/case-detail/case-data/reducers/case-data-reducer";
import addCaseManualReducer from "../common_components/add-case-manual/reducer/add-case-manual-reducer";
import remitDetailReducer from "../pages/external-audit/case-list/remit-detail/reducers/remit-detail-reducer";
import myTasksPageReducer from "../pages/my-tasks/reducers/my-tasks-page-reducer";
import denialsPredictorReducer from "../pages/analyzer/denials-predictor/reducers/denials-predictor-reducer";
import manageDeletedEntities from "../pages/internal-audit-setup/manage-deleted-entities/reducers/manage-deleted-entities-reducer";
import esmdSubmissionReducer from "../common_components/case-details/esMd-dashboard/reducers/esmd-submission-reducer";
import configureEmUtilization from "../pages/analyzer/configure-em-utilization/reducers/configure-em-utilization-reducer";
import externalUsersReducer from "../pages/user-management/external-users/reducer/external-users-reducer";
import totalAndRejectedReducer from "../pages/external-dashboard/dashboard-widgets/total-submissions-widget/reducers/total-submissions-widget-reducer";
import totalFilesSubmittedReducer from "../pages/external-dashboard/dashboard-widgets/total-files-widget/reducers/total-files-widget-reducer";
import reviewContractorResponseTimeReducer from "../pages/external-dashboard/dashboard-widgets/review-contractor-response-time-widget/reducers/review-contractor-response-time-widget-reducer";
import targetedDenialAnalysisReportReducer from "../common_components/targeted-denial-analysis/reducers/targeted-denial-analysis-reducer"
import denialReasons from "../pages/external-audit-setup/denial-reasons/reducers/denial-reasons-reducer";
import commentReducer from "../pages/analyzer/denials-predictor/reducers/comment-reducer";
import riskAreaOutcomeReducer from "../pages/analyzer/risk-area-outcomes/reducers/risk-area-outcome-reducer";
import carcMappingReducer from "../pages/custom-CARC-mapping/reducers/custom-CARC-mapping-reducer";
import lineItemProcedureCodesReducer from "../pages/customer-setup/custom-code-sets/LineItemProcedureCodes/reducers/line-item-procedure-codes-reducer";
import payerGroupsReducer from "../pages/customer-setup/payer-groups/reducers/payer-groups-reducer";
import viewCARCMappingsReducer from "../common_components/thoughtspot-sdk-app-embed/reducers/view-carc-mappings-reducer";
import taskGroupReducer from "../pages/user-management/task-groups/reducer/task-group-reducer";
import emdrInboxReducer from "../pages/emdr-inbox/inbox/reducers/emdr-ibox-reducer";
import eacaseFieldsReducer from "../common_components/case-details/reducers/ea-case-fields-reducer";
import headerFooterReducer from "../pages/report-configuration/header-footer/reducers/header-footer-reducer";
import emdrEnrollmentReducer from "../pages/external-audit-setup/emdr-enrollment/reducers/emdr-enrollment-reducer";
import reportTemplateReducer from "../pages/report-configuration/report-templates/reducers/report-template-reducer";
import targetRationaleReducer from "../pages/external-audit-setup/target-rationale/reducers/targetRationaleReducer";
import editReportTemplateReducer from "../pages/report-configuration/edit-report-template/reducer/edit-report-template-reducer";
import aiSummaryReducer from "../common_components/thoughtspot-sdk-app-embed/reducers/ai-summary-reducer";
import downloadPopupReducer from "../common_components/thoughtspot-sdk-app-embed/reducers/download-liveboard-reducer";
import caseListPageReducer from "../pages/external-audit/case-list-page/reducer/case-list-page-reducer";
import caseSearchPageReducer from "../pages/case-search/reducer/case-search-page-reducer";
import billDataConfigurationReducer from "../pages/customer-setup/data-configuration/reducers/bill-data-configuration-reducer";
import policySearchReducer from "../pages/code-and-policy-search/policy-search/reducers/policy-search-reducer";
import myCasesReducer from "../pages/my-assignments/my-cases/reducers/my-cases-reducer";
const rootReducer = combineReducers({
  form: formReducer,
  mdaeNavigationBarReducer,
  mdaeCommonReducer,
  documentManagementReducer,
  mdaePageHeaderReducer,
  appReducer,
  taskTemplateReducer,
  categoryManagementReducer,
  myTaskReducer,
  userTaskListReducer,
  outcomesReducer,
  bellCurveReportParameterReducer,
  externalAuditReducer,
  notificationAndSystemMessagesReducer,
  auditListReducer,
  caseFieldsReducer,
  sourcesReducer,
  requesterReducer,
  roundTaskReducer,
  caseCountReducer,
  eaDashboardReducer,
  myTaskDasboardReducer,
  auditViewUserTaskListReducer,
  myExternalAuditByStatusReducer,
  caseSearchReducer,
  caseListReducer,
  bulkUpdatePopupReducer,
  manageDeletedExternalAudit,
  processTemplateReducer,
  billHistoryReducer,
  caseDataReducer,
  caseDetailReducer,
  auditPropertiesReducer,
  addCaseManualReducer,
  remitDetailReducer,
  myTasksPageReducer,
  denialsPredictorReducer,
  manageDeletedEntities,
  esmdSubmissionReducer,
  configureEmUtilization,
  externalUsersReducer,
  totalAndRejectedReducer,
  totalFilesSubmittedReducer,
  reviewContractorResponseTimeReducer,
  denialReasons,
  targetedDenialAnalysisReportReducer,
  commentReducer,
  riskAreaOutcomeReducer,
  lineItemProcedureCodesReducer,
  payerGroupsReducer,
  carcMappingReducer,
  viewCARCMappingsReducer,
  taskGroupReducer,
  emdrInboxReducer,
  eacaseFieldsReducer,
  emdrEnrollmentReducer,
  headerFooterReducer,
  targetRationaleReducer,
  aiSummaryReducer ,
  downloadPopupReducer,
  reportTemplateReducer,
  editReportTemplateReducer,
  caseListPageReducer,
  caseSearchPageReducer,
  billDataConfigurationReducer,
  policySearchReducer,
  myCasesReducer
});

export default rootReducer;
